import { render } from "./ResultDialog.vue?vue&type=template&id=45ea98c2&scoped=true"
import script from "./ResultDialog.vue?vue&type=script&lang=js"
export * from "./ResultDialog.vue?vue&type=script&lang=js"

import "./ResultDialog.vue?vue&type=style&index=0&id=45ea98c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ea98c2"]])

export default __exports__